<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout v-if="ServerError" wrap justify-center>
      <v-flex px-5 pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <ServerError />
      </v-flex>
    </v-layout>
    <v-layout wrap v-else>
      <v-flex pt-5 xs12 sm12 md12 lg12 xl12 text-center>
        <v-card>
          <v-card-title class="elevation-1">
            <span>Footer Data</span>
            <v-spacer></v-spacer>
            <!-- <v-flex pt-5 xl3 lg3 md3 pb-2 sm3 xs3 px-5>
              <v-dialog
                :retain-focus="false"
                v-model="dialog"
                persistent
                max-width="1000px"
                :key="dialog"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="red"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Add
                  </v-btn>
                </template>
                <v-card>
                  <v-form v-model="addslider">
                    <v-card-title>
                      <span class="headline">Add Page Contributors</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                            <v-text-field
                                v-model="Name"
                                label="Name"
                                outlined
                            ></v-text-field>                          </v-col>
                              <v-col cols="12" sm="12" md="12">
                            <v-text-field
                                v-model="Title"
                                label="Title"
                                outlined
                            ></v-text-field>                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <div id="app">
                              <vue-editor v-model="Value"></vue-editor>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="dialogclose()">
                        Close
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        :disabled="!addslider"
                        @click="add()"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </v-card>
              </v-dialog>
            </v-flex>  -->
            <!-- <v-flex pt-5 xl3 lg3 md3 pb-2 sm3 xs3 px-5>
              <v-dialog v-model="dialogDelete" max-width="600px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    class="mr-2"
                    outlined
                    v-on="on"
                    v-bind="attrs"
                    color="red"
                  >
                    Delete
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title
                    >Are you sure you want to delete this Careers?</v-card-title
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogDelete = false"
                      >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="deleteItem()"
                      >OK</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-flex> -->
          </v-card-title>
          <div>
            <v-layout wrap>
              <!-- <v-flex xs12 pt-5 v-if="Title">
                <v-text-field outlined v-model="name" label="Title"></v-text-field>
              </v-flex> -->
              <v-flex pt-5 px-2 xl12 xs12 sm12 lg12 md12 text-left>
                <span>Please Add Footer Content</span>
              </v-flex>
              <v-flex pt-5 px-2 xl12 xs12 sm12 lg12 md12>
                <div id="app">
                  <vue-editor v-model="content"></vue-editor>
                </div>
              </v-flex>
              <v-flex pt-5 px-2 xl12 xs12 sm12 lg12 md12 text-left>
                <span>Please Add Contact</span>
              </v-flex>
              <v-flex pt-5 px-2 xl12 xs12 sm12 lg12 md12>
                <div id="app">
                  <vue-editor v-model="contact"></vue-editor>
                </div>
              </v-flex>
              <v-flex pt-5 px-2 xl12 xs12 sm12 lg12 md12 text-left>
                <span>Please Add Twitter Link</span>
              </v-flex>
              <v-flex xs12 px-2 pt-5>
                <v-text-field
                  v-model="twitterlink"
                  dense
                  outlined
                  label="Twitter Link"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex pt-5 px-2 xl12 xs12 sm12 lg12 md12 text-left>
                <span>Please Add Facebook Link</span>
              </v-flex>
              <v-flex xs12 pt-5 px-2>
                <v-text-field
                  v-model="fblink"
                  dense
                  outlined
                  label="Facebook Link"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex pt-5 px-2 xl12 xs12 sm12 lg12 md12 text-left>
                <span>Please Add Linkedin Link</span>
              </v-flex>
              <v-flex xs12 pt-5 px-2>
                <v-text-field
                  v-model="linkedInlink"
                  dense
                  outlined
                  label="Linkedin Link"
                  single-line
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout pt-5 px-2 pb-5 wrap justify-end>
              <v-flex xs6 md2 v-if="staticArray != null">
                <v-btn
                  block
                  tile
                  color="#3ea56e"
                  dark
                  :ripple="false"
                  style="text-transform: none"
                  depressed
                  @click="edit()"
                >
                  Save Changes
                </v-btn>
              </v-flex>
              <v-flex v-else>
                <v-btn outlined color="red" @click="add()"> Add </v-btn>
              </v-flex>
            </v-layout>
          </div>
          <!-- <div v-else>
            <h4 style="padding-top: 30px">No data avilable.....</h4>
          </div> -->
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor,
  },
  props: ["name"],
  data() {
    return {
      checkbox: true,
      ServerError: false,
      file: null,
      showsnackbar: false,
      editingitem: [],
      msg: null,
      pages: 0,
      twitterlink: "",
      fblink: "",
      linkedInlink: "",
      content: null,
      contact: "",
      Title: null,
      widthOfCard: "250px",
      appLoading: false,
      currentPage: 1,
      footerId: null,
      totalData: 0,
      totalRows: 0,
      dialogDelete: false,
      search: "",
      dialog: false,
      editdialog: false,
      staticArray: [],
      addslider: false,
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 15) || "Name must be less than 15 characters",
      ],
      Rules: [(value) => !!value || "Required."],
    };
  },
  beforeMount() {
    this.getData();
  },
  watch: {
    name() {
      this.getData();
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/footer/list",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.staticArray = response.data.data;
          if (this.staticArray) this.content = this.staticArray.content;
          this.contact = this.staticArray.contact;
          this.footerId = this.staticArray._id;
          this.linkedInlink = this.staticArray.linkedInlink;
          this.fblink = this.staticArray.fblink;
          this.twitterlink = this.staticArray.twitterlink;
          // this.Title = this.staticArray.Title;
          this.pages = response.data.pages;
          this.totalData = response.data.count;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
    edit() {
      var data = {};
      data["contact"] = this.contact;
      data["content"] = this.content;
      data["linkedInlink"] = this.linkedInlink;
      data["twitterlink"] = this.twitterlink;
      data["fblink"] = this.fblink;
      data["footerid"] = this.footerId;
      axios({
        url: "/footer/update",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.getData();
            this.msg = "Updated Sucessfully";
            this.showsnackbar = true;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.$emit("stepper", {
            ServerError: true,
          });
          console.log(err);
        });
    },
    add() {
      var data = {};
      data["contact"] = this.contact;
      data["content"] = this.content;
      data["linkedInlink"] = this.linkedInlink;
      data["twitterlink"] = this.twitterlink;
      data["fblink"] = this.fblink;
      axios({
        url: "/footer/add",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.getData();
            this.msg = "Updated Sucessfully";
            this.showsnackbar = true;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.$emit("stepper", {
            ServerError: true,
          });
          console.log(err);
        });
    },
  },
};
</script>
